// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mk9D33C0AnH1wsxA0XsT {
  width: 100%;
  border-radius: 0.375rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(22 121 208 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(224 244 255 / var(--tw-bg-opacity, 1));
  padding: 1.25rem;
}

.eyv_P9q1FSLDX4r26NVV {
  display: flex;
  width: 100%;
  flex-direction: column;
}

@media (min-width: 1024px) {

  .eyv_P9q1FSLDX4r26NVV {
    flex-direction: row;
  }
}

.nqoeIZ1gkcKLqdvqoYAx {
  width: 100%;
  padding-right: 0px;
  padding-bottom: 1.25rem;
}

@media (min-width: 1024px) {

  .nqoeIZ1gkcKLqdvqoYAx {
    width: 70%;
    padding-right: 1.5rem;
    padding-bottom: 0px;
  }
}

.JAuGvdVCc8JP0GgsPaCE {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.tLVTgdsUL_wJIa_6Kwbl {
  display: flex;
  height: 2.5rem;
  width: 2.5rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(22 121 208 / var(--tw-border-opacity, 1));
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(22 121 208 / var(--tw-text-opacity, 1));
}

.HbWr2DP3YpvfKlGxVwNP {
  width: 100%;
  min-width: 0px;
}

.w__Iv0cCg8YazN0urzFv {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.uLCPmGY2B0RpuH8yeB6W {
  margin: 0px;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
}

.bNEg2hUdamZHdz5Zei6w {
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.b0m3g0md6B_MAClLXrc9 {
  margin: 0px;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(22 121 208 / var(--tw-text-opacity, 1));
}

.bjjyaw8wKiOyhenMEjIB {
  margin-top: 0.5rem;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  -moz-column-gap: 2rem;
       column-gap: 2rem;
  row-gap: 0.25rem;
}

.F5MFJkwXJ_aUTbEUB9HO {
  margin: 0px;
}

.UNHVRup0Mn8pLfdDVfSA {
  width: 100%;
  border-top-width: 2px;
  border-left-width: 0px;
  --tw-border-opacity: 1;
  border-color: rgb(22 121 208 / var(--tw-border-opacity, 1));
  padding-top: 1.25rem;
  padding-left: 0px;
}

@media (min-width: 1024px) {

  .UNHVRup0Mn8pLfdDVfSA {
    width: 30%;
    border-top-width: 0px;
    border-left-width: 2px;
    padding-top: 0px;
    padding-left: 1.5rem;
  }
}

.imAqkke78SUa8pMIW2ho {
  text-align: right;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1));
}

@media (min-width: 1024px) {

  .imAqkke78SUa8pMIW2ho {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

/* Customer Consent page */
.rMiyCyBakOl7Hr6N3Oqv {
  padding: 1.25rem;
}
@media (min-width: 1024px) {

  .rMiyCyBakOl7Hr6N3Oqv {
    padding: 1.5rem;
  }
}

.rMiyCyBakOl7Hr6N3Oqv .JAuGvdVCc8JP0GgsPaCE {
  gap: 1rem;
}

@media (min-width: 1024px) {

  .rMiyCyBakOl7Hr6N3Oqv .JAuGvdVCc8JP0GgsPaCE {
    gap: 1.25rem;
  }
}

.rMiyCyBakOl7Hr6N3Oqv .tLVTgdsUL_wJIa_6Kwbl {
  height: 2.75rem;
  width: 2.75rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

@media (min-width: 1024px) {

  .rMiyCyBakOl7Hr6N3Oqv .tLVTgdsUL_wJIa_6Kwbl {
    height: 3rem;
    width: 3rem;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

.rMiyCyBakOl7Hr6N3Oqv .w__Iv0cCg8YazN0urzFv {
  gap: 0.5rem;
}

@media (min-width: 1024px) {

  .rMiyCyBakOl7Hr6N3Oqv .w__Iv0cCg8YazN0urzFv {
    gap: 0.75rem;
  }
}

.rMiyCyBakOl7Hr6N3Oqv .uLCPmGY2B0RpuH8yeB6W {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

@media (min-width: 1024px) {

  .rMiyCyBakOl7Hr6N3Oqv .uLCPmGY2B0RpuH8yeB6W {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}

.rMiyCyBakOl7Hr6N3Oqv .imAqkke78SUa8pMIW2ho {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

@media (min-width: 1024px) {

  .rMiyCyBakOl7Hr6N3Oqv .imAqkke78SUa8pMIW2ho {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.rMiyCyBakOl7Hr6N3Oqv .bNEg2hUdamZHdz5Zei6w {
  margin-top: 1rem;
}

@media (min-width: 1024px) {

  .rMiyCyBakOl7Hr6N3Oqv .bNEg2hUdamZHdz5Zei6w {
    margin-top: 1.25rem;
  }
}

.rMiyCyBakOl7Hr6N3Oqv .b0m3g0md6B_MAClLXrc9 {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

@media (min-width: 1024px) {

  .rMiyCyBakOl7Hr6N3Oqv .b0m3g0md6B_MAClLXrc9 {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
}

.rMiyCyBakOl7Hr6N3Oqv .bjjyaw8wKiOyhenMEjIB {
  margin-top: 0.75rem;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  -moz-column-gap: 2rem;
       column-gap: 2rem;
  row-gap: 0.5rem;
}

@media (min-width: 1024px) {

  .rMiyCyBakOl7Hr6N3Oqv .bjjyaw8wKiOyhenMEjIB {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.rMiyCyBakOl7Hr6N3Oqv .F5MFJkwXJ_aUTbEUB9HO {
  font-size: 1rem;
  line-height: 1.75rem;
}

@media (min-width: 1024px) {

  .rMiyCyBakOl7Hr6N3Oqv .F5MFJkwXJ_aUTbEUB9HO {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

.rMiyCyBakOl7Hr6N3Oqv .UNHVRup0Mn8pLfdDVfSA {
  padding-top: 1.25rem;
  padding-left: 0px;
}

@media (min-width: 1024px) {

  .rMiyCyBakOl7Hr6N3Oqv .UNHVRup0Mn8pLfdDVfSA {
    padding-top: 0px;
    padding-left: 1.5rem;
  }
}

.rMiyCyBakOl7Hr6N3Oqv .Qeas1PhJrhN7hR3FvMhH > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

.rMiyCyBakOl7Hr6N3Oqv .fNxUaKo16o4v54WlNpPX {
  gap: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
}

@media (min-width: 1024px) {

  .rMiyCyBakOl7Hr6N3Oqv .fNxUaKo16o4v54WlNpPX {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

.rMiyCyBakOl7Hr6N3Oqv .Z53HjYkpGnGpQmEu8Srk {
  font-weight: 600;
}

.WQIvGHqt4bQ0H4jbHwO7 {
  font-style: italic;
  font-weight: normal;
  font-size: large;
  color: #000;
}

.c7vPFQY5lMsmk5WRJ2Dw {
  color: #000;
  font-weight: normal;
}

.UNHVRup0Mn8pLfdDVfSA {
  width: 100%;
  border-top-width: 2px;
  border-left-width: 0px;
  --tw-border-opacity: 1;
  border-color: rgb(22 121 208 / var(--tw-border-opacity, 1));
  padding-top: 1.25rem;
  padding-left: 0px;
}

@media (min-width: 1024px) {

  .UNHVRup0Mn8pLfdDVfSA {
    width: 30%;
    border-top-width: 0px;
    border-left-width: 2px;
    padding-top: 0px;
    padding-left: 1.5rem;
  }
}

.UNHVRup0Mn8pLfdDVfSA {
  display: flex;
  flex-direction: column;
}

.BLKCywfbiijWX8l7K0m3 {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.Qeas1PhJrhN7hR3FvMhH {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  font-size: 20px;
}

._DmPI6QoXOHzmc9qTGRt,
.ae53nvtZQiz6gkEKV5EY {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.b5ntAv1eDsSn45PG3uiS,
.fNxUaKo16o4v54WlNpPX {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  width: 100%;
  -moz-column-gap: 2px;
       column-gap: 2px;
}

.b5ntAv1eDsSn45PG3uiS > span:first-child,
.fNxUaKo16o4v54WlNpPX > span:first-child {
  font-size: 20px;
  text-align: left;
  white-space: nowrap;
}

.b5ntAv1eDsSn45PG3uiS .Z53HjYkpGnGpQmEu8Srk,
.fNxUaKo16o4v54WlNpPX .Z53HjYkpGnGpQmEu8Srk {
  text-align: right;
  white-space: nowrap;
}

.ae53nvtZQiz6gkEKV5EY {
  margin-top: 4px;
  min-width: 0;
}

.ae53nvtZQiz6gkEKV5EY .fNxUaKo16o4v54WlNpPX {
  grid-template-columns: minmax(0, 1fr) auto;
  -moz-column-gap: 8px;
       column-gap: 8px;
  width: 100%;
  font-size: 20px;
}

.ae53nvtZQiz6gkEKV5EY .Z53HjYkpGnGpQmEu8Srk {
  font-weight: 600;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PledgeConsentApproval/components/PledgeDetails/PledgeDetails.module.css"],"names":[],"mappings":"AACE;EAAA,WAAkE;EAAlE,uBAAkE;EAAlE,iBAAkE;EAAlE,sBAAkE;EAAlE,2DAAkE;EAAlE,kBAAkE;EAAlE,4DAAkE;EAAlE;AAAkE;;AAIlE;EAAA,aAAuC;EAAvC,WAAuC;EAAvC;AAAuC;;AAAvC;;EAAA;IAAA;EAAuC;AAAA;;AAIvC;EAAA,WAAkD;EAAlD,kBAAkD;EAAlD;AAAkD;;AAAlD;;EAAA;IAAA,UAAkD;IAAlD,qBAAkD;IAAlD;EAAkD;AAAA;;AAIlD;EAAA,aAA6B;EAA7B,uBAA6B;EAA7B;AAA6B;;AAI7B;EAAA,aAAoI;EAApI,cAAoI;EAApI,aAAoI;EAApI,cAAoI;EAApI,mBAAoI;EAApI,uBAAoI;EAApI,qBAAoI;EAApI,iBAAoI;EAApI,sBAAoI;EAApI,2DAAoI;EAApI,mBAAoI;EAApI,oBAAoI;EAApI,gBAAoI;EAApI,oBAAoI;EAApI;AAAoI;;AAIpI;EAAA,WAAqB;EAArB;AAAqB;;AAIrB;EAAA,aAAwC;EAAxC,eAAwC;EAAxC,mBAAwC;EAAxC;AAAwC;;AAIxC;EAAA,WAAgC;EAAhC,mBAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;;AAIhC;EAAA,gBAA6C;EAA7C,aAA6C;EAA7C,eAA6C;EAA7C,mBAA6C;EAA7C;AAA6C;;AAI7C;EAAA,WAA+C;EAA/C,iBAA+C;EAA/C,iBAA+C;EAA/C,gBAA+C;EAA/C,oBAA+C;EAA/C;AAA+C;;AAI/C;EAAA,kBAA4C;EAA5C,aAA4C;EAA5C,gDAA4C;EAA5C,qBAA4C;OAA5C,gBAA4C;EAA5C;AAA4C;;AAI5C;EAAA;AAAU;;AAIV;EAAA,WAAoH;EAApH,qBAAoH;EAApH,sBAAoH;EAApH,sBAAoH;EAApH,2DAAoH;EAApH,oBAAoH;EAApH;AAAoH;;AAApH;;EAAA;IAAA,UAAoH;IAApH,qBAAoH;IAApH,sBAAoH;IAApH,gBAAoH;IAApH;EAAoH;AAAA;;AAIpH;EAAA,iBAAkD;EAAlD,mBAAkD;EAAlD,oBAAkD;EAAlD,oBAAkD;EAAlD;AAAkD;;AAAlD;;EAAA;IAAA,kBAAkD;IAAlD;EAAkD;AAAA;;AAGpD,0BAA0B;AAExB;EAAA;AAAiB;AAAjB;;EAAA;IAAA;EAAiB;AAAA;;AAIjB;EAAA;AAAqB;;AAArB;;EAAA;IAAA;EAAqB;AAAA;;AAIrB;EAAA,eAAmD;EAAnD,cAAmD;EAAnD,mBAAmD;EAAnD;AAAmD;;AAAnD;;EAAA;IAAA,YAAmD;IAAnD,WAAmD;IAAnD,kBAAmD;IAAnD;EAAmD;AAAA;;AAInD;EAAA;AAAqB;;AAArB;;EAAA;IAAA;EAAqB;AAAA;;AAIrB;EAAA,kBAA0B;EAA1B;AAA0B;;AAA1B;;EAAA;IAAA,iBAA0B;IAA1B;EAA0B;AAAA;;AAI1B;EAAA,mBAA2B;EAA3B;AAA2B;;AAA3B;;EAAA;IAAA,eAA2B;IAA3B;EAA2B;AAAA;;AAI3B;EAAA;AAAmB;;AAAnB;;EAAA;IAAA;EAAmB;AAAA;;AAInB;EAAA,mBAA2B;EAA3B;AAA2B;;AAA3B;;EAAA;IAAA,kBAA2B;IAA3B;EAA2B;AAAA;;AAI3B;EAAA,mBAAsD;EAAtD,gDAAsD;EAAtD,qBAAsD;OAAtD,gBAAsD;EAAtD;AAAsD;;AAAtD;;EAAA;IAAA;EAAsD;AAAA;;AAItD;EAAA,eAAqC;EAArC;AAAqC;;AAArC;;EAAA;IAAA,mBAAqC;IAArC;EAAqC;AAAA;;AAIrC;EAAA,oBAAgC;EAAhC;AAAgC;;AAAhC;;EAAA;IAAA,gBAAgC;IAAhC;EAAgC;AAAA;;AAIhC;EAAA,uBAAgB;EAAhB,8DAAgB;EAAhB;AAAgB;;AAIhB;EAAA,WAAiC;EAAjC,eAAiC;EAAjC;AAAiC;;AAAjC;;EAAA;IAAA,mBAAiC;IAAjC;EAAiC;AAAA;;AAIjC;EAAA;AAAoB;;AAGtB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAGE;EAAA,WAAoH;EAApH,qBAAoH;EAApH,sBAAoH;EAApH,sBAAoH;EAApH,2DAAoH;EAApH,oBAAoH;EAApH;AAAoH;;AAApH;;EAAA;IAAA,UAAoH;IAApH,qBAAoH;IAApH,sBAAoH;IAApH,gBAAoH;IAApH;EAAoH;AAAA;;AADtH;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,oBAAe;OAAf,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,oBAAe;OAAf,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".pledgeDetails {\n  @apply border-2 border-info-400 bg-lightBlue rounded-md p-5 w-full;\n}\n\n.mainContainer {\n  @apply flex flex-col lg:flex-row w-full;\n}\n\n.leftSection {\n  @apply w-full lg:w-[70%] pr-0 lg:pr-6 pb-5 lg:pb-0;\n}\n\n.leftContent {\n  @apply flex items-start gap-4;\n}\n\n.indexCircle {\n  @apply w-10 h-10 shrink-0 rounded-full border-2 border-info-400 text-info-400 flex items-center justify-center font-semibold text-lg;\n}\n\n.contentWrapper {\n  @apply min-w-0 w-full;\n}\n\n.ticketHeader {\n  @apply flex items-center gap-3 flex-wrap;\n}\n\n.ticketNumber {\n  @apply m-0 text-lg font-semibold;\n}\n\n.amountWrapper {\n  @apply mt-4 flex items-center gap-2 flex-wrap;\n}\n\n.amount {\n  @apply m-0 text-2xl font-semibold text-info-400;\n}\n\n.articles {\n  @apply mt-2 grid grid-cols-2 gap-x-8 gap-y-1;\n}\n\n.article {\n  @apply m-0;\n}\n\n.rightSection {\n  @apply w-full lg:w-[30%] border-t-2 lg:border-t-0 border-l-0 lg:border-l-2 border-info-400 pt-5 lg:pt-0 pl-0 lg:pl-6;\n}\n\n.consentGeneratedAt {\n  @apply text-right text-sm lg:text-xs text-gray-500;\n}\n\n/* Customer Consent page */\n.customerConsent {\n  @apply p-5 lg:p-6;\n}\n\n.customerConsent .leftContent {\n  @apply gap-4 lg:gap-5;\n}\n\n.customerConsent .indexCircle {\n  @apply w-11 h-11 lg:w-12 lg:h-12 text-lg lg:text-xl;\n}\n\n.customerConsent .ticketHeader {\n  @apply gap-2 lg:gap-3;\n}\n\n.customerConsent .ticketNumber {\n  @apply text-xl lg:text-2xl;\n}\n\n.customerConsent .consentGeneratedAt {\n  @apply text-sm lg:text-base;\n}\n\n.customerConsent .amountWrapper {\n  @apply mt-4 lg:mt-5;\n}\n\n.customerConsent .amount {\n  @apply text-3xl lg:text-4xl;\n}\n\n.customerConsent .articles {\n  @apply grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-2 mt-3;\n}\n\n.customerConsent .article {\n  @apply text-base lg:text-lg leading-7;\n}\n\n.customerConsent .rightSection {\n  @apply pt-5 lg:pt-0 pl-0 lg:pl-6;\n}\n\n.customerConsent .details {\n  @apply space-y-2;\n}\n\n.customerConsent .detailRow {\n  @apply text-base lg:text-lg gap-2;\n}\n\n.customerConsent .detailValue {\n  @apply font-semibold;\n}\n\n.orText {\n  font-style: italic;\n  font-weight: normal;\n  font-size: large;\n  color: #000;\n}\n\n.amountInWords {\n  color: #000;\n  font-weight: normal;\n}\n\n.rightSection {\n  @apply w-full lg:w-[30%] border-t-2 lg:border-t-0 border-l-0 lg:border-l-2 border-info-400 pt-5 lg:pt-0 pl-0 lg:pl-6;\n  display: flex;\n  flex-direction: column;\n}\n\n.rightContent {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  width: 100%;\n  font-size: 20px;\n}\n\n.dateDetails,\n.weightDetails {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.dateRow,\n.detailRow {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  width: 100%;\n  column-gap: 2px;\n}\n\n.dateRow > span:first-child,\n.detailRow > span:first-child {\n  font-size: 20px;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.dateRow .detailValue,\n.detailRow .detailValue {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.weightDetails {\n  margin-top: 4px;\n  min-width: 0;\n}\n\n.weightDetails .detailRow {\n  grid-template-columns: minmax(0, 1fr) auto;\n  column-gap: 8px;\n  width: 100%;\n  font-size: 20px;\n}\n\n.weightDetails .detailValue {\n  font-weight: 600;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pledgeDetails": `Mk9D33C0AnH1wsxA0XsT`,
	"mainContainer": `eyv_P9q1FSLDX4r26NVV`,
	"leftSection": `nqoeIZ1gkcKLqdvqoYAx`,
	"leftContent": `JAuGvdVCc8JP0GgsPaCE`,
	"indexCircle": `tLVTgdsUL_wJIa_6Kwbl`,
	"contentWrapper": `HbWr2DP3YpvfKlGxVwNP`,
	"ticketHeader": `w__Iv0cCg8YazN0urzFv`,
	"ticketNumber": `uLCPmGY2B0RpuH8yeB6W`,
	"amountWrapper": `bNEg2hUdamZHdz5Zei6w`,
	"amount": `b0m3g0md6B_MAClLXrc9`,
	"articles": `bjjyaw8wKiOyhenMEjIB`,
	"article": `F5MFJkwXJ_aUTbEUB9HO`,
	"rightSection": `UNHVRup0Mn8pLfdDVfSA`,
	"consentGeneratedAt": `imAqkke78SUa8pMIW2ho`,
	"customerConsent": `rMiyCyBakOl7Hr6N3Oqv`,
	"details": `Qeas1PhJrhN7hR3FvMhH`,
	"detailRow": `fNxUaKo16o4v54WlNpPX`,
	"detailValue": `Z53HjYkpGnGpQmEu8Srk`,
	"orText": `WQIvGHqt4bQ0H4jbHwO7`,
	"amountInWords": `c7vPFQY5lMsmk5WRJ2Dw`,
	"rightContent": `BLKCywfbiijWX8l7K0m3`,
	"dateDetails": `_DmPI6QoXOHzmc9qTGRt`,
	"weightDetails": `ae53nvtZQiz6gkEKV5EY`,
	"dateRow": `b5ntAv1eDsSn45PG3uiS`
};
export default ___CSS_LOADER_EXPORT___;
